// Setup expanding fieldsets
// e.g. Spa Wellness Requests
function kd_cog_Form_Fieldsets() {
  // check if form loaded
  let f = jQuery('form.cog-form');
  if(f.length) {
    let l = jQuery('fieldset > legend.cog-label');
    console.info('Count: fieldset > legend.cog-label', l.length);
    l.each(function(i, el) {
      jQuery(el).on('click', function() { 
        console.info('clicked');
        let c = $( this ).parent().find('div.el-checkbox-group');
        // console.info('closest .el-checkbox-group', c);
        c.toggleClass('show');
      });
    });
    console.info('Completed: kd_cog_Form_Fieldsets');
    return;
  }
  // repeat
  setTimeout(kd_cog_Form_Fieldsets, 500);
}
  
document.addEventListener("DOMContentLoaded", (event) => {
  console.info('Ready: cog-form-spa-wellness-requests');
  kd_cog_Form_Fieldsets();
});
